module.exports = __webpack_public_path__ + "static/media/faq.ddbfc0c2.svg";